import React, { useRef, useState } from "react";

import {
  View,
  Text,
  TouchableOpacity,
  ActivityIndicator,
  Modal,
  Image,
} from "react-native";

import { StatusBar } from "expo-status-bar";
import { LinearGradient } from "expo-linear-gradient";
import { toast } from "../../utils/toast"
import api from "../../services/api";
import axios from "axios";
import * as DocumentPicker from 'expo-document-picker';

import { MaterialIcons } from "@expo/vector-icons";
import { Feather } from '@expo/vector-icons';

import styles from "./style";
import Header from "./header";
import Input from "../../components/Form/Input";
import MaskedInput from "../../components/Form/MaskedInput";
import ForeignInput from "../../components/Form/ForeignInput";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import CheckboxDocument from "../../components/Form/CheckboxDocument";

import moment from "moment";

import { RootSiblingParent } from "react-native-root-siblings";
import ModalSuccess from "../../components/ModalSuccess";

export default function Register({ navigation }) {
  const progressValue = 1 / 9;

  const [errors, setErrors] = useState({});

  const [authId, setAuthId] = useState("");
  const [formStep, setFormStep] = useState(0);
  const [progress, setProgress] = useState(progressValue);
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const [rg, setRg] = useState("");
  const [cpf, setCpf] = useState("");
  const [name, setName] = useState("");
  const [auth, setAuth] = useState(0);
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState();
  const [password, setPassword] = useState("");
  const [birthday, setBirthday] = useState("");
  const [foreign, setForeign] = useState(false);
  const [passport, setPassport] = useState();
  const [password_confirmation, setPasswordConfirmation] = useState("");
  const [document, setDocument] = useState(0);
  const [socialReason, setSocialreason] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [cpfLegalResponsible, setCpfLegalResponsible] = useState("");
  const [nameLegalResponsible, setNameLegalResponsible] = useState("");
  const [socialContractLegalResponsible, setSocialContractLegalResponsible] = useState(null);

  function isFirstStep() {
    const firstStep = document === 2 ? 9 : 0
    return formStep == firstStep;
  }

  function handleCodeVerification() {
    setIsLoading(true);
    api.post(`emails/${authId}/confirm-email`, {
      confirmation_code: parseInt(auth),
    })
      .then(response => {
        handleStepChange();
      })
      .catch(({ response }) => {
        const { status } = response;
        if (status === 403) {
          const { data } = response;
          setErrors({ auth: data.message });
          //authInputField.current.focus()
          setAuth(0)
        } else {
          toast("Um erro inesperado aconteceu, por favor, tente mais tarde", "#DA1414");
        }
      })
      .finally(() => setIsLoading(false));
  }

  function handleSendCodeRequest() {
    setIsLoading(true);
    api.post("/emails/signup", { email: email })
      .then(response => {
        setAuthId(response.data.id);
        handleStepChange();
      })
      .catch(error => {
        let response = error.response;
        const { status } = response;

        if (status === 422) {
          const { data } = response;
          const { email } = data.message;
          toast(email[0], "#DA1414", 3000);
        } else {
          toast(
            "Um erro inesperado aconteceu, por favor, tente mais tarde", "#DA1414");
        }
      })
      .finally(() => setIsLoading(false));
  }

  function handleSignup(data) {
    setIsLoading(true);

    api.post("/clients/signup", data)
      .then((res) => {
        setModalVisible(true);
        setProgress(1);
      })
      .catch(({ response }) => {
        const { status } = response;
        if (status === 422) {
          toast(
            "Verifique se todos os campos foram preenchidos corretamente",
            "#FFCC00",
            3000
          );
        } else
          toast(
            "Um erro inesperado aconteceu, por favor, tente mais tarde",
            "#DA1414",
            3000
          );
      })
      .finally(() => setIsLoading(false));
  }

  function handleStepChange(isForward = true, close = false) {
    if (!isForward) {
      if (isFirstStep() || close) navigation.navigate("Welcome");
      setProgress((currentProgress) => currentProgress - progressValue);
      setFormStep((currentStep) => currentStep - 1);
    } else {
      setProgress((currentProgress) => currentProgress + progressValue);
      setFormStep((currentStep) => currentStep + 1);
    }
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function compareStrings(stringA, stringB) {

    const manipulatedA = stringA.toLowerCase().replace(/[^0-9a-z ]/g, '');
    const manipulatedB = stringB.toLowerCase().replace(/[^0-9a-z ]/g, '');
    const splittedBySpaceA = manipulatedA.split(' ');
    const splittedBySpaceB = manipulatedB.split(' ');
    
    let valid = false;
    //condições de validação
    let sizeA = splittedBySpaceA.length;
    let sizeB = splittedBySpaceB.length;
    if (manipulatedA === manipulatedB) {
      valid = true;
    } else {
      if (splittedBySpaceA[0] === splittedBySpaceB[0]) {
        if (splittedBySpaceA[sizeA - 1] === splittedBySpaceB[sizeB - 1]) {
          //primeiro e último iguais
          valid = true;
        }
      }
      if (splittedBySpaceA.join('') === splittedBySpaceB.join('')) {
        //sao iguais sem espaço e manipulados
        valid = true;
      }

      if(!valid) {
        let alphaStringA = {
          a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0, i: 0, j: 0, k: 0, l: 0, m: 0, n: 0, o: 0, p: 0, q: 0, r: 0, s: 0, t: 0, u: 0, v: 0, w: 0, x: 0, y: 0, z: 0
        };
        let alphaStringB = {
          a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0, i: 0, j: 0, k: 0, l: 0, m: 0, n: 0, o: 0, p: 0, q: 0, r: 0, s: 0, t: 0, u: 0, v: 0, w: 0, x: 0, y: 0, z: 0
        };
        const splittedA = manipulatedA.split('');
        const splittedB = manipulatedB.split('');
        for(let i = 0; i < splittedA.length; i++) {
          let letter = splittedA[i];
          if(alphaStringA[letter] || alphaStringA[letter] === 0) {
            alphaStringA[letter]++;
          }
        }
        for(let i = 0; i < splittedB.length; i++) {
          let letter = splittedB[i];
          if(alphaStringB[letter] || alphaStringB[letter] === 0) {
            alphaStringB[letter]++;
          }
        }
        let consideredLength = Math.max(manipulatedA.length, manipulatedB.length);
        let countDiference = 0;
        for (var keyA in alphaStringA){
          if (alphaStringA.hasOwnProperty(keyA) && alphaStringB.hasOwnProperty(keyA)) {
            countDiference += Math.abs(alphaStringA[keyA] - alphaStringB[keyA]);
          }
        }
        if(countDiference <= Math.ceil(0.5 * consideredLength)) {
          valid = true;
        }
      }
    }
    return valid;
  }


  async function isValidForm() {
    switch (formStep) {
      case 1:
        if (!name) {
          setErrors({ name: "É necessário informar seu nome" });
          return false;
        }
        return true;

      case 2:
        const validDate = moment(birthday, "DD/MM/YYYY", true).isValid();
        if (!birthday) {
          setErrors({
            birthday: "É necessário informar sua data de nascimento",
          });
          return false;
        }
        if (!validDate) {
          setErrors({
            birthday: "É necessário informar uma data válida",
          });
          return false;
        }
        return true;

      case 3:
        if (!cpf) {
          setErrors({
            cpf: "É necessário informar seu CPF",
          });
          return false;
        }
        if (cpf.length < 14) {
          setErrors({
            cpf: "É necessário informar um CPF válido",
          });
          return false;
        }

        var data = JSON.stringify({
          "Datasets": "basic_data",
          "q": `doc{${cpf}}`,
          "AccessToken": "5a066da6-c5aa-40f8-809d-f0c14dd73b73",
          "url": "https://bigboost.bigdatacorp.com.br/peoplev2"
        });

        var config = {
          method: 'post',
          url: 'https://api.gpxexchange.com.br/api/cors',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data
        };


        return await axios(config)
          .then(function (response) {

            if (response.data.Status.basic_data[0].Code != 0) {
              setErrors({
                cpf: "É necessário informar CPF válido",
              });
              return false;
            }

            const DateBigData = moment.utc(response.data.Result[0].BasicData.BirthDate).locale('pt-br').format('L');

            if (DateBigData != birthday) {
              setErrors({
                cpf: "É necessário informar sua data de nascimento de acordo com seus documentos",
              });
              return false;
            }

            const NameBigData = response.data.Result[0].BasicData.Name

            let valid = compareStrings(NameBigData, name);

            if (!valid) {
              setErrors({
                cpf: "É necessário informar seu nome de acordo com seus documentos",
              });
              return false;
            }

            return true;
          })
          .catch(function (error) {
            setErrors({
              cpf: "Erro BigData",
            });
            return false
          });
      // case 4:
      //   if (!foreign && !rg) {
      //     setErrors({
      //       rg: "É necessário informar seu RG",
      //     });
      //     return false;
      //   }

      //   if (foreign && !passport) {
      //     setErrors({
      //       passport: "É necessário informar seu passaporte",
      //     });

      //     return false;
      //   }

      //   if (foreign && !country) {
      //     setErrors({
      //       country: "É necessário informar sua nacionalidade",
      //     });

      //     return false;
      //   }
      //   return true;

      case 4:
        if (!email) {
          setErrors({
            email: "É necessário informar seu e-mail",
          });
          return false;
        }

        if (email && !validateEmail(email)) {
          setErrors({
            email: "É necessário informar um e-mail válido",
          });
          return false;
        }
        return true;
      case 5:
        if (!auth) {
          setErrors({
            auth: "É necessário informar um código de validação",
          });
          return false;
        }

        if (auth.length < 4) {
          setErrors({
            auth: "É necessário informar um código de 4 dígitos",
          });
          return false;
        }

        return true;
      case 6:
        if (!password) {
          setErrors({
            password: "É necessário informar uma senha",
          });
          return false;
        }

        if (password.length < 6) {
          setErrors({
            password: "É necessário informar uma senha de 6 dígitos",
          });
          return false;
        }

        return true;

      case 7:
        if (!password_confirmation) {
          setErrors({
            password_confirmation: "É necessário confirmar sua senha",
          });
          return false;
        }

        if (password !== password_confirmation) {
          setErrors({
            password_confirmation: "As senhas precisam ser as mesmas",
          });
          return false;
        }

        return true;

      case 9:
        if (!socialReason) {
          setErrors({ socialReason: "É necessário informar a sua razão social." });
          return false;
        }

        return true;

      case 10:
        if (!cnpj) {
          setErrors({
            cnpj: "É necessário informar seu CNPJ",
          });
          return false;
        }
        if (cnpj.length < 18) {
          setErrors({
            cnpj: "É necessário informar um CNPJ válido",
          });
          return false;
        }
        //TIRAR ESSE AQUI:
        return true;
        var data = JSON.stringify({
          "Datasets": "basic_data",
          "q": `doc{${cnpj}}`,
          "AccessToken": "5a066da6-c5aa-40f8-809d-f0c14dd73b73",
          "url": 'https://bigboost.bigdatacorp.com.br/companies'
        });

        var config = {
          method: 'post',
          url: 'https://api.gpxexchange.com.br/api/cors',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        };


      // return await axios(config)
      //   .then(function (response) {

      //     if (response.data.Status.basic_data[0].Code != 0) {
      //       setErrors({
      //         cnpj: "É necessário informar CNPJ válido",
      //       });
      //       return false;
      //     }

      //     const RazaoSocial = response.data.Result[0].BasicData.OfficialName

      //     let valid = compareStrings(RazaoSocial, socialReason);

      //     //check
      //     if (!valid) {
      //       setErrors({ cnpj: "É necessário informar a sua razão social de acordo com sua documentação." });
      //       return false;
      //     }

      //     return true;

      //   })
      //   .catch(function (error) {
      //     setErrors({
      //       cnpj: "Erro BigData",
      //     });
      //     return false
      //   });

      case 11:
        if (!cpfLegalResponsible) {
          setErrors({
            cpfLegalResponsible: "É necessário informar o CPF do responsável legal",
          });
          return false;
        }

        if (!nameLegalResponsible) {
          setErrors({
            nameLegalResponsible: "É necessário informar o nome do responsável legal",
          });
          return false;
        }

        //TIRAR ESSE AQUI:
        return true;


        var data = JSON.stringify({
          "Datasets": "basic_data",
          "q": `doc{${cpfLegalResponsible}}`,
          "AccessToken": "5a066da6-c5aa-40f8-809d-f0c14dd73b73",
          "url": "https://bigboost.bigdatacorp.com.br/peoplev2"
        });

        var config = {
          method: 'post',
          url: 'https://api.gpxexchange.com.br/api/cors',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        };


      // return await axios(config)
      //   .then(function (response) {

      //     if (response.data.Status.basic_data[0].Code != 0) {
      //       setErrors({
      //         cpfLegalResponsible: "É necessário informar CPF válido",
      //       });
      //       return false;
      //     }

      //     const NameBigData = response.data.Result[0].BasicData.Name

      //     let valid = compareStrings(NameBigData, nameLegalResponsible);

      //     if (!valid) {
      //       //   console.log(NameBigData.toLowerCase(), nameLegalResponsible.toLowerCase())
      //       setErrors({
      //         nameLegalResponsible: "É necessário informar seu nome de acordo com seus documentos",
      //       });
      //       return false;
      //     }

      //     return true;
      //   })
      //   .catch(function (error) {
      //     setErrors({
      //       nameLegalResponsible: "Erro BigData",
      //     });
      //     return false
      //   });
      case 12:
        if (!email) {
          setErrors({
            email: "É necessário informar seu e-mail",
          });
          return false;
        }

        if (email && !validateEmail(email)) {
          setErrors({
            email: "É necessário informar um e-mail válido",
          });
          return false;
        }
        return true;

      case 13:
        if (!auth) {
          setErrors({
            auth: "É necessário informar um código de validação",
          });
          return false;
        }

        if (auth.length < 4) {
          setErrors({
            auth: "É necessário informar um código de 4 dígitos",
          });
          return false;
        }

        return true;
      case 14:
        if (!password) {
          setErrors({
            password: "É necessário informar uma senha",
          });
          return false;
        }

        if (password.length < 6) {
          setErrors({
            password: "É necessário informar uma senha de 6 dígitos",
          });
          return false;
        }

        return true;

      case 15:
        if (!password_confirmation) {
          setErrors({
            password_confirmation: "É necessário confirmar sua senha",
          });
          return false;
        }

        if (password !== password_confirmation) {
          setErrors({
            password_confirmation: "As senhas precisam ser as mesmas",
          });
          return false;
        }

        return true;
    }
  }

  async function handleSubmit() {
    if (! await isValidForm()) return;

    setErrors({});

    if (document === 1) {
      if (formStep == 4) {
        handleSendCodeRequest();
        return;
      }

      if (formStep == 5) {
        handleCodeVerification();
        return;
      }
    } else {
      if (formStep == 12) {
        handleSendCodeRequest();
        return;
      }

      if (formStep == 13) {
        handleCodeVerification();
        return;
      }
    }

    if (document === 1) {
      if (formStep === 7) {
        const splitedName = name.split(" ");
        const firstName = splitedName.shift();
        const lastNames = splitedName.join(" ");

        const data = {
          user: {
            email,
            password,
            email_id: authId,
          },
          client: {
            cpf,
            passport,
            rg_number: rg,
            first_name: firstName,
            last_name: lastNames,
            birthday: moment(birthday, "DD/MM/YYYY").format("YYYY-MM-DD"),
            socialReason: "",
            cnpj: "",
            cpfLegalResponsible: "",
            nameLegalResponsible: "",
            socialContractLegalResponsible: "",
            is_pj: false
          },
          address: {
            country_id: country ?? 31,
          },
        };

        handleSignup(data);
      } else {
        handleStepChange();
      }
    } else {
      if (formStep === 15) {
        // const splitedName = name.split(" ");
        // const firstName = splitedName.shift();
        // const lastNames = splitedName.join(" ");

        const data = {
          user: {
            email,
            password,
            email_id: authId,
          },
          client: {
            cpf: "",
            passport: "",
            rg_number: "",
            first_name: socialReason,
            last_name: "",
            birthday: "",
            socialReason,
            cnpj,
            cpfLegalResponsible,
            nameLegalResponsible,
            socialContractLegalResponsible,
            is_pj: true
          },
          address: {
            country_id: country ?? 31,
          },
        };

        handleSignup(data);
      } else {
        handleStepChange();
      }
    }
  }

  const pickDocument = async () => {
    let result = await DocumentPicker.getDocumentAsync({});

    if (result.cancelled) {
      return false;
    }

    let localUri = result.uri;
    let filename = localUri.split('/').pop();

    let match = /\.(\w+)$/.exec(filename);
    let type = match ? `image/${match[1]}` : `image`;

    setSocialContractLegalResponsible(result);
  }

  return (
    <RootSiblingParent>
      <Header
        isFirstStep={isFirstStep}
        onActionPressed={(close) => handleStepChange(false, close)}
        progress={progress}
      />
      <View style={styles.container}>
        <View style={styles.form}>
          {formStep === 0 ? (
            <View style={{ flexDirection: "row" }}>
              <CheckboxDocument
                size={20}
                color="#1FBFB5"
                selected={false}
                text="Pessoa Física"
                style={styles.checkbox}
                textStyle={styles.checkboxText}
                type={1}
                onPress={(selected) => {
                  setDocument(selected);
                  setFormStep(1);
                }}
              />

              <CheckboxDocument
                size={20}
                color="#1FBFB5"
                selected={false}
                text="Pessoa Jurídica"
                style={styles.checkbox}
                textStyle={styles.checkboxText}
                type={2}
                onPress={(selected) => {
                  setDocument(selected);
                  setFormStep(9);
                }}
              />
            </View>
          ) : null}

          {/* {
              document === 1 ? ( */}
          <View style={{ flex: 1 }}>
            {formStep === 1 ? (
              <Input
                label="Digite seu nome"
                value={name}
                onValueChange={(value) => setName(value)}
                error={errors.name}
              />

            ) : null}

            {formStep === 2 ? (
              <MaskedInput
                value={birthday}
                mask="99/99/9999"
                keyboardType="numeric"
                label="Digite sua data de nascimento"
                onValueChange={(value) => setBirthday(value)}
                error={errors.birthday}
              />
            ) : null}

            {formStep === 3 ? (
              <MaskedInput
                mask="999.999.999-99"
                keyboardType="numeric"
                label="Digite seu CPF"
                value={cpf}
                onValueChange={(value) => setCpf(value)}
                error={errors.cpf}
              />
            ) : null}

            {/* {formStep === 4 ? (
                <ForeignInput
                  handleForeign={(value) => {
                    setForeign(value);
                  }}
                  onValueChange={(prop, value) => {
                    switch (prop) {
                      case "rg":
                        setRg(value);
                        break;
                      case "passport":
                        setPassport(value);
                        break;
                      case "country_id":
                        setCountry(value);
                        break;
                    }
                  }}
                  errors={errors}
                />
              ) : null} */}

            {formStep === 4 ? (
              <Input
                label="Digite seu e-mail"
                value={email}
                onValueChange={(value) => setEmail(value)}
                error={errors.email}
              />
            ) : null}
            {formStep === 5 ? (
              <AuthCodeInput
                cellCount={4}
                value={auth}
                onValueChange={(value) => setAuth(value)}
                label="Enviamos um código em seu e-mail, insira abaixo:"
                error={errors.auth}
              />
            ) : null}

            {formStep === 6 ? (
              <AuthCodeInput
                cellCount={6}
                isPassword={true}
                value={password}
                onValueChange={(value) => setPassword(value)}
                label="Crie a sua senha"
                error={errors.password}
              />
            ) : null}
            {formStep === 7 ? (
              <AuthCodeInput
                cellCount={6}
                isPassword={true}
                value={password_confirmation}
                onValueChange={(value) => setPasswordConfirmation(value)}
                label="Confirme a sua senha"
                error={errors.password_confirmation}
              />
            ) : null}
            {/* ) : ( */}
            {formStep === 9 ? (
              <Input
                label="Razão Social"
                value={socialReason}
                onValueChange={(value) => setSocialreason(value)}
                error={errors.socialReason}
              />
            ) : null}

            {formStep === 10 ? (
              <MaskedInput
                mask="99.999.999/9999-99"
                keyboardType="numeric"
                label="Digite seu CNPJ"
                value={cnpj}
                onValueChange={(value) => setCnpj(value)}
                error={errors.cnpj}
              />
            ) : null}

            {formStep === 11 ? (
              <>
                <MaskedInput
                  mask="999.999.999-99"
                  keyboardType="numeric"
                  label="Digite o CPF do responsável legal"
                  value={cpfLegalResponsible}
                  onValueChange={(value) => setCpfLegalResponsible(value)}
                  error={errors.cpfLegalResponsible}
                />
                <Input
                  label="Digite o nome do responsável legal"
                  value={nameLegalResponsible}
                  onValueChange={(value) => setNameLegalResponsible(value)}
                  error={errors.nameLegalResponsible}
                />

                {/* <View style={styles.containerSocialContract}>
                    <Text style={styles.description}>Contrato social</Text>

                    <TouchableOpacity style={styles.btnAdd} onPress={pickDocument}>
                      <Feather name="plus" size={24} color="black" style={styles.iconAdd} />
                    </TouchableOpacity>

                    {
                      socialContractLegalResponsible && (
                        <Text style={{ fontWeight: 'bold', marginTop: 20 }}>Arquivo: <Text style={{ fontWeight: 'normal' }}>{socialContractLegalResponsible.name}</Text></Text>
                      )
                    }
                  </View> */}
              </>
            ) : null}
            <>
              {formStep === 12 ? (
                <Input
                  label="Digite seu e-mail"
                  value={email}
                  onValueChange={(value) => setEmail(value)}
                  error={errors.email}
                />
              ) : null}

              {formStep === 13 ? (
                <AuthCodeInput
                  cellCount={4}
                  value={auth}
                  onValueChange={(value) => setAuth(value)}
                  label="Enviamos um código em seu e-mail, insira abaixo:"
                  error={errors.auth}
                />
              ) : null}
              {formStep === 14 ? (
                <AuthCodeInput
                  cellCount={6}
                  isPassword={true}
                  value={password}
                  onValueChange={(value) => setPassword(value)}
                  label="Crie a sua senha"
                  error={errors.password}
                />
              ) : null}

              {formStep === 15 ? (
                <AuthCodeInput
                  cellCount={6}
                  isPassword={true}
                  value={password_confirmation}
                  onValueChange={(value) => setPasswordConfirmation(value)}
                  label="Confirme a sua senha"
                  error={errors.password_confirmation}
                />
              ) : null}

            </>
          </View>

          <View style={styles.actionContainer}>
            <TouchableOpacity onPress={handleSubmit}>
              <LinearGradient
                start={{ x: -1, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={["#16195B", "#1FBFB5"]}
                style={styles.button}
              >
                {isLoading ? (
                  <ActivityIndicator color="#FFF" size="large" />
                ) : null}

                {!isLoading ? (
                  <Text style={styles.buttonText}>
                    {
                      document === 1
                        ? formStep < 8
                          ? "Continuar"
                          : "Cadastrar-se"
                        : formStep < 14
                          ? "Continuar"
                          : "Cadastrar-se"
                    }
                  </Text>
                ) : null}
              </LinearGradient>
            </TouchableOpacity>
          </View>

          <Modal
            animationType="fade"
            transparent={false}
            visible={modalVisible}
            statusBarTranslucent={true}
            onRequestClose={() => setModalVisible((visible) => !visible)}
          >
            <ModalSuccess
              handleCloseModal={() => {
                setModalVisible(false);
                navigation.navigate("Welcome");
              }}
              text={"Parabéns! Sua conta foi criada com"}
              textColor={"sucesso!"}
              subtitle={""}
              img={1}
              positionHeader={"right"}
            />
          </Modal>
        </View>
      </View>
    </RootSiblingParent>
  );
}
